<template>
  <div class="afm-subscribe-container">
    <p class="sub-header">{{ $t('subscribe_more_info') }}</p>
    <div class="sub-button-container">
      <!-- <a class="button-title">Enter your Email</a> -->
      <input
        type="text"
        :placeholder="$t('enter_email')"
        v-model="subscribeEmail"
        @keyup.enter="subscribe"
        class="subscribe-field"
      />
      <button
        v-if="subscribeEmailStatus === 'default'"
        type="button"
        class="subscribe-submit"
        @click="subscribe">
        {{ $i18n.locale === 'en' ? 'Subscribe' : '订阅' }}
      </button>
      <button v-if="subscribeEmailStatus === 'success'" type="button" class="subscribe-submit" disabled>
        <i class="fa fa-check" aria-hidden="true"></i>
      </button>
      <button v-if="subscribeEmailStatus === 'error'" type="button" class="subscribe-submit" disabled>
        <i class="fa fa-times" aria-hidden="true"></i>
      </button>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "subscribe",
  data() {
    return {
      subscribeEmail: '',
      subscribeEmailStatus: 'default',
    }
  },
  methods: {
    ...mapActions('profile', ['fetchSubscribeEmail', 'postSubscribeEmail', 'putUnsubscribeEmail']),
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    subscribe() {
      if (this.subscribeEmail) {
        if (this.validEmail(this.subscribeEmail)) {
          this.postSubscribeEmail(this.subscribeEmail)
            .then(res => {
              this.subscribeEmailStatus = 'success';
            }).catch(err => {
            this.subscribeEmailStatus = 'error';
            setTimeout(() => {
              this.subscribeEmailStatus = 'default';
            }, 800);
          });
        } else {
          this.subscribeEmailStatus = 'error';
          setTimeout(() => {
            this.subscribeEmailStatus = 'default';
          }, 800);
        }
      }
    }
  }
}
</script>

<style lang="less">
.afm-subscribe-container {
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 24px;
  margin-bottom: 20px;
  background-color: transparent;

  .sub-header {
    width: 100%;
    max-width: 920px;
    font-family: 'Source Sans Pro';
    font-size: 20px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.6;
    letter-spacing: normal;
    color: #FFFDF0;
    margin: 0 0 24px;
    text-align: center;
  }

  .sub-button-container {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    max-width: 920px;
    height: 68px;
    padding: 0;
    overflow: hidden;
    background: transparent;
    border: 2px solid rgba(255, 255, 255, 0.85);
    border-radius: 10px;

    ::placeholder {
      font-size: 20px;
      font-family: 'Source Sans Pro';
      color: rgba(255, 255, 255, 0.65) !important;
    }

    input[type="text"] {
      min-width: 0;
      height: 100%;
      font-family: 'Source Sans Pro';
      font-size: 20px;
      font-weight: 400;
      color: white !important;
      margin: 0;
    }

    .subscribe-field {
      flex: 1;
      width: auto;
      padding: 0 28px;
      background: transparent;
      border: none;
      border-radius: 0;
    }

    .subscribe-field:focus {
      outline: none;
    }

    .subscribe-submit {
      flex: 0 0 145px;
      align-self: stretch;
      width: 145px;
      padding: 0 20px;
      font-family: 'Source Sans Pro';
      font-size: 22px;
      font-weight: 700;
      color: #111111;
      background: #FFFDF0;
      border: 0;
      border-left: 1px solid rgba(255, 255, 255, 0.75);
      cursor: pointer;

      &:disabled {
        cursor: default;
      }

      .fa-check {
        color: #4f9f42;
        font-size: 26px;
      }

      .fa-times {
        color: #fa6400;
        font-size: 26px;
      }
    }
  }
}

@media only screen and (max-width: 1200px) {
  .afm-subscribe-container {
    .sub-button-container {
      max-width: 760px;
    }
  }
}

@media only screen and (max-width: 600px) {
  .afm-subscribe-container {
    padding: 0 16px;

    .sub-header {
      font-size: 16px;
    }

    .sub-button-container {
      height: 56px;

      .subscribe-field {
        padding: 0 16px;
      }

      .subscribe-submit {
        flex-basis: 96px;
        width: 96px;
        padding: 0 12px;
        font-size: 18px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/afw-subscribe/afw-subscribe.vue